// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2X1Th","image":"Header_image__3_RNW","name":"Header_name__6DwM2","info":"Header_info__2Dtd0","infoRow":"Header_infoRow__YVSgN"};